<template>
    <div class="asideNav">
        <div class="brand">
            <img src="../assets/icon/pangao_logo.png" alt="" />
        </div>
        <!-- <div :class="['navTab',currentTab=='dataCenter'?'active':'']" @click="changeTab('dataCenter')">
            <img src="../assets/img/data.png"  />
            数据中心
    </div>-->
        <div :class="['navTab', currentTab == 'userList' ? 'active' : '']" @click="changeTab('userList')">
            <img src="../assets/icon/pangao_user_ic2.png" v-if="currentTab == 'userList'" />
            <img src="../assets/icon/pangao_user_ic.png" v-else />
            用户管理
        </div>
        <div :class="['navTab', currentTab == 'pushManage' ? 'active' : '']" @click="changeTab('pushManage')">
            <img src="../assets/icon/pangao_push_ic2.png" v-if="currentTab == 'pushManage'" />
            <img src="../assets/icon/pangao_push_ic.png" v-else />
            推送管理
        </div>
        <div :class="['navTab', currentTab == 'feedBack' ? 'active' : '']" @click="changeTab('feedBack')">
            <img src="../assets/icon/pangao_opinion_ic2.png" v-if="currentTab == 'feedBack'" />
            <img src="../assets/icon/pangao_opinion_ic.png" v-else />
            意见反馈
        </div>
        <div :class="['navTab', currentTab == 'management' ? 'active' : '']" @click="changeTab('management')">
            <img src="../assets/icon/pangao_applets_ic2.png" v-if="currentTab == 'management'" />
            <img src="../assets/icon/pangao_applets_ic.png" v-else />
            小程序管理
        </div>
        <div :class="['navTab', currentTab == 'password' ? 'active' : '']" @click="changeTab('password')">
            <img src="../assets/icon/pangao_password_ic2.png" v-if="currentTab == 'password'" />
            <img src="../assets/icon/pangao_password_ic.png" v-else />
            修改密码
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentTab: "userList",
        };
    },
    methods: {
        changeTab(val) {
            this.currentTab = val;
            this.$router.push({ name: val });
        },
    },
    created() {
        this.currentTab = sessionStorage.getItem("currentTab") || "userList";
    },
};
</script>

<style lang="scss" scoped>
.asideNav {
    width: 300px;
    box-sizing: border-box;
    padding-top: 120px;
    background: #2b333e;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.brand {
    position: absolute;
    top: 0%;
    left: 0%;
    z-index: 1000;
    height: 80px;
    width: 100%;
    font-size: 28px;
    background: #ff8914;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.navTab {
    display: flex;
    align-items: center;
    // justify-content: center;
    padding-left: 20%;
    width: 100%;
    height: 70px;
    line-height: 70px;
    color: #fff;
    font-size: 18px;
    position: relative;
    user-select: none;
    cursor: pointer;
    img {
        margin-right: 10px;
        width: 30px;
        height: 30px;
    }
}
.navTab.active {
    background: #1c232c;
    color: #ff8914;
    position: relative;
    &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 5px;
        background: #ff8914;
    }
}
@media only screen and (max-width: 1700px) {
    .asideNav {
        width: 16%;
    }
    .navTab {
        font-size: 16px;
    }
}
</style>
